import { render, staticRenderFns } from "./MenuPrincipal.vue?vue&type=template&id=fa86c3b6&scoped=true&"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js&"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa86c3b6",
  null
  
)

export default component.exports